import { Action } from '../actions.types';

export const hasActions = (obj: any): obj is { actions: Action[] } =>
  !!obj && obj.actions !== undefined && Array.isArray(obj.actions);
